module.exports = "/_next/static/images/3c638da3ec42587bc966d4bd6ff32323-javier-ibarreche.png.webp";